
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Clock, CheckCircle } from 'lucide-react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

type RequestCardStatusProps = {
  status: string;
  createdAt: string;
};

const formatDate = (dateString: string) => {
  try {
    return format(new Date(dateString), 'dd MMM yyyy', { locale: fr });
  } catch {
    return dateString;
  }
};

export const RequestCardStatus = ({ status, createdAt }: RequestCardStatusProps) => {
  return (
    <div className="flex items-center space-x-2 mb-2">
      <Badge 
        variant={status === 'pending' ? 'outline' : 'default'}
        className="flex items-center gap-1"
      >
        {status === 'pending' ? 
          <><Clock size={12} /> En attente</> : 
          <><CheckCircle size={12} /> Complété</>
        }
      </Badge>
      <span className="text-gray-500 text-sm">
        {formatDate(createdAt)}
      </span>
    </div>
  );
};
